import { Modal } from "@mui/material";
import styled from "styled-components";
import Colors from "../../../../../../constants/Colors";

export const ExamsCardModal = styled(Modal)<{
  useBackgroundColor?: boolean;
}>`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ useBackgroundColor }) =>
    useBackgroundColor && "background-color: rgba(0, 0, 0, 0.3);"}
`;
export const ExamsCardModalContainer = styled.div<{ isMobile?: boolean }>`
  display: flex;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  overflow: scroll;
  background-color: #ffffff;
  width: ${(props) => (props.isMobile ? "90%" : "70vw")};

  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
`;

export const ContainerExamsFlexRow = styled.div`
  display: flex;
`;

export const ModalExamsCardContainer = styled.div`
  padding: 36px 102px;
  width: 90%;

  @media screen and (max-width: 760px) {
    padding: 10px;
    width: 100%;
  }
`;

export const ModalExamsMedicCardContainer = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 760px) {
    flex-direction: column;
  }

  gap: 10px;
  width: 100%;
  /* justify-content: center; */
`;

export const ModalExamsTextCardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalExamsTimeCardContainer = styled.div`
  display: flex;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  gap: 10px;
  align-items: center;
`;

export const ModalExamsHoursContainer = styled.div`
  display: flex;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  ${Colors.SPM500}
`;

export const ModalExamsHourCard = styled.div`
  display: flex;

  border-radius: 4px;

  text-align: center;
  @media screen and (max-width: 760px) {
    text-align: left;
  }
  background: ${Colors.SPM50};
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  max-height: 30px;
  gap: 10px;
`;

export const ModalExamsSubTextContainer = styled.div`
  text-align: left;
`;

export const ModalExamsButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
`;

export const ExamsModalOverFlow = styled.div<{ isMobile?: boolean }>`
  overflow-y: scroll;
  height: 250px;
  margin-bottom: 5px;
`;
